import React, { useState } from 'react';
import { PlusIcon, SearchIcon, EditIcon, TrashIcon, CheckCircleIcon, XCircleIcon, UserIcon } from 'lucide-react';
import { PinVerificationModal } from './PinVerificationModal';
interface Permission {
  id: string;
  name: string;
  description: string;
  group: string;
}
interface User {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  department: string;
  isActive: boolean;
  permissions: string[];
}
const permissionGroups = [{
  id: 'scanning',
  name: 'Scanner',
  permissions: [{
    id: 'scanner_login',
    name: 'Anmeldung Scanner',
    description: 'Erlaubt die Anmeldung am Scanner-System',
    group: 'scanning'
  }]
}, {
  id: 'production',
  name: 'Produktion',
  permissions: [{
    id: 'print_labels',
    name: 'Etiketten drucken',
    description: 'Erlaubt das Drucken von Etiketten',
    group: 'production'
  }, {
    id: 'approve_production_plan',
    name: 'Produktionsplan freigeben',
    description: 'Erlaubt das Freigeben von Produktionsplänen',
    group: 'production'
  }, {
    id: 'edit_production_plan',
    name: 'Produktionsplan bearbeiten',
    description: 'Erlaubt das Bearbeiten von Produktionsplänen',
    group: 'production'
  }]
}, {
  id: 'data',
  name: 'Daten',
  permissions: [{
    id: 'edit_data',
    name: 'Daten bearbeiten',
    description: 'Erlaubt das Bearbeiten von Stammdaten',
    group: 'data'
  }]
}];
const initialUsers: User[] = [{
  id: 'U001',
  username: 'mschmidt',
  firstName: 'Max',
  lastName: 'Schmidt',
  email: 'max.schmidt@kleinemas.de',
  department: 'Produktion',
  isActive: true,
  permissions: ['scanner_login', 'print_labels']
}];
function UserForm({
  user,
  onSave,
  onCancel
}: {
  user: User;
  onSave: (user: User) => void;
  onCancel: () => void;
}) {
  const [formData, setFormData] = useState(user);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handlePermissionToggle = (permissionId: string) => {
    setFormData(prev => ({
      ...prev,
      permissions: prev.permissions.includes(permissionId) ? prev.permissions.filter(id => id !== permissionId) : [...prev.permissions, permissionId]
    }));
  };
  return <form onSubmit={e => {
    e.preventDefault();
    onSave(formData);
  }} className="space-y-6" data-id="element-1197">
      <div className="grid grid-cols-2 gap-4" data-id="element-1198">
        <div data-id="element-1199">
          <label className="block text-sm font-medium mb-1" data-id="element-1200">Benutzername</label>
          <input type="text" name="username" value={formData.username} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg p-2" required data-id="element-1201" />
        </div>
        <div data-id="element-1202">
          <label className="block text-sm font-medium mb-1" data-id="element-1203">E-Mail</label>
          <input type="email" name="email" value={formData.email} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg p-2" required data-id="element-1204" />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4" data-id="element-1205">
        <div data-id="element-1206">
          <label className="block text-sm font-medium mb-1" data-id="element-1207">Vorname</label>
          <input type="text" name="firstName" value={formData.firstName} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg p-2" required data-id="element-1208" />
        </div>
        <div data-id="element-1209">
          <label className="block text-sm font-medium mb-1" data-id="element-1210">Nachname</label>
          <input type="text" name="lastName" value={formData.lastName} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg p-2" required data-id="element-1211" />
        </div>
      </div>
      <div data-id="element-1212">
        <label className="block text-sm font-medium mb-1" data-id="element-1213">Abteilung</label>
        <input type="text" name="department" value={formData.department} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg p-2" required data-id="element-1214" />
      </div>
      <div data-id="element-1215">
        <label className="block text-sm font-medium mb-4" data-id="element-1216">Berechtigungen</label>
        <div className="space-y-6" data-id="element-1217">
          {permissionGroups.map(group => <div key={group.id} className="bg-gray-50 rounded-lg p-4" data-id="element-1218">
              <h4 className="font-medium text-gray-700 mb-3" data-id="element-1219">{group.name}</h4>
              <div className="space-y-3" data-id="element-1220">
                {group.permissions.map(permission => <label key={permission.id} className="flex items-start gap-3 cursor-pointer" data-id="element-1221">
                    <div className="flex items-center h-5 mt-0.5" data-id="element-1222">
                      <input type="checkbox" checked={formData.permissions.includes(permission.id)} onChange={() => handlePermissionToggle(permission.id)} className="h-4 w-4 text-[#ec8301] rounded border-gray-300 focus:ring-[#ec8301]" data-id="element-1223" />
                    </div>
                    <div data-id="element-1224">
                      <div className="font-medium" data-id="element-1225">{permission.name}</div>
                      <div className="text-sm text-gray-500" data-id="element-1226">
                        {permission.description}
                      </div>
                    </div>
                  </label>)}
              </div>
            </div>)}
        </div>
      </div>
      <div data-id="element-1227">
        <label className="flex items-center gap-2" data-id="element-1228">
          <input type="checkbox" name="isActive" checked={formData.isActive} onChange={e => setFormData(prev => ({
          ...prev,
          isActive: e.target.checked
        }))} className="h-4 w-4 text-[#ec8301] rounded border-gray-300 focus:ring-[#ec8301]" data-id="element-1229" />
          <span className="text-sm font-medium" data-id="element-1230">Benutzer ist aktiv</span>
        </label>
      </div>
      <div className="flex justify-end gap-3 pt-6 border-t border-gray-200" data-id="element-1231">
        <button type="button" onClick={onCancel} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50" data-id="element-1232">
          Abbrechen
        </button>
        <button type="submit" className="px-4 py-2 bg-[#ec8301] text-white rounded-lg hover:bg-[#ec8301]/90" data-id="element-1233">
          Speichern
        </button>
      </div>
    </form>;
}
export function UserManagement() {
  const [users, setUsers] = useState(initialUsers);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [isEditing, setIsEditing] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isPinVerified, setIsPinVerified] = useState(false);
  const [showPinModal, setShowPinModal] = useState(true);
  const handleNewUser = () => {
    setSelectedUser({
      id: `U${String(users.length + 1).padStart(3, '0')}`,
      username: '',
      firstName: '',
      lastName: '',
      email: '',
      department: '',
      isActive: true,
      permissions: []
    });
    setIsEditing(true);
  };
  const filteredUsers = users.filter(user => user.username.toLowerCase().includes(searchTerm.toLowerCase()) || user.firstName.toLowerCase().includes(searchTerm.toLowerCase()) || user.lastName.toLowerCase().includes(searchTerm.toLowerCase()) || user.email.toLowerCase().includes(searchTerm.toLowerCase()));
  if (!isPinVerified) {
    return <div className="p-6 h-full" data-id="element-1234">
        <header className="mb-8" data-id="element-1235">
          <h1 className="text-3xl font-bold text-[#e20019]" data-id="element-1236">
            Benutzerverwaltung
          </h1>
          <p className="text-gray-600" data-id="element-1237">
            Verwalten Sie Benutzer und deren Berechtigungen
          </p>
        </header>
        <div className="flex items-center justify-center h-[calc(100%-8rem)]" data-id="element-1238">
          <div className="text-center" data-id="element-1239">
            <p className="text-xl text-gray-600 mb-2" data-id="element-1240">
              Dieser Bereich ist PIN-geschützt
            </p>
            <p className="text-gray-500 mb-4" data-id="element-1241">
              Bitte geben Sie Ihre PIN ein, um fortzufahren
            </p>
            <button onClick={() => setShowPinModal(true)} className="px-4 py-2 bg-[#ec8301] text-white rounded-lg hover:bg-[#ec8301]/90" data-id="element-1242">
              PIN eingeben
            </button>
          </div>
        </div>
        <PinVerificationModal isOpen={showPinModal} onClose={() => setShowPinModal(false)} onVerify={() => {
        setIsPinVerified(true);
        setShowPinModal(false);
      }} data-id="element-1243" />
      </div>;
  }
  return <div className="p-6 h-full" data-id="element-1244">
      <header className="mb-8" data-id="element-1245">
        <h1 className="text-3xl font-bold text-[#e20019]" data-id="element-1246">
          Benutzerverwaltung
        </h1>
        <p className="text-gray-600" data-id="element-1247">
          Verwalten Sie Benutzer und deren Berechtigungen
        </p>
      </header>
      <div className="flex flex-col lg:flex-row gap-6 h-[calc(100%-8rem)]" data-id="element-1248">
        <div className="lg:w-1/3 flex flex-col" data-id="element-1249">
          <div className="mb-4 flex gap-2" data-id="element-1250">
            <div className="relative flex-1" data-id="element-1251">
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-1252" />
              <input type="text" placeholder="Benutzer suchen..." className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ec8301]" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1253" />
            </div>
            <button onClick={handleNewUser} className="bg-[#ec8301] hover:bg-[#e20019] text-white rounded-lg px-4 py-2 flex items-center transition-colors" data-id="element-1254">
              <PlusIcon className="h-5 w-5 mr-1" data-id="element-1255" />
              <span data-id="element-1256">Neu</span>
            </button>
          </div>
          <div className="bg-white rounded-lg shadow flex-1 overflow-auto" data-id="element-1257">
            {filteredUsers.length === 0 ? <div className="p-4 text-center text-gray-500" data-id="element-1258">
                Keine Benutzer gefunden
              </div> : <ul className="divide-y divide-gray-200" data-id="element-1259">
                {filteredUsers.map(user => <li key={user.id} data-id="element-1260">
                    <button onClick={() => {
                setSelectedUser(user);
                setIsEditing(false);
              }} className={`w-full text-left p-4 hover:bg-gray-50 ${selectedUser?.id === user.id ? 'bg-gray-100' : ''}`} data-id="element-1261">
                      <div className="flex items-center gap-3" data-id="element-1262">
                        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${user.isActive ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-400'}`} data-id="element-1263">
                          <UserIcon className="h-5 w-5" data-id="element-1264" />
                        </div>
                        <div data-id="element-1265">
                          <div className="font-medium" data-id="element-1266">
                            {user.firstName} {user.lastName}
                          </div>
                          <div className="text-sm text-gray-500" data-id="element-1267">
                            {user.username}
                          </div>
                        </div>
                      </div>
                      <div className="mt-2 flex items-center gap-2" data-id="element-1268">
                        <span className="text-sm text-gray-500" data-id="element-1269">
                          {user.department}
                        </span>
                        {user.isActive ? <span className="text-xs bg-green-100 text-green-600 px-2 py-0.5 rounded-full" data-id="element-1270">
                            Aktiv
                          </span> : <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full" data-id="element-1271">
                            Inaktiv
                          </span>}
                      </div>
                    </button>
                  </li>)}
              </ul>}
          </div>
        </div>
        <div className="lg:w-2/3 bg-white rounded-lg shadow p-6 overflow-auto" data-id="element-1272">
          {!selectedUser ? <div className="h-full flex items-center justify-center text-gray-500" data-id="element-1273">
              <p data-id="element-1274">
                Wählen Sie einen Benutzer aus oder erstellen Sie einen neuen
              </p>
            </div> : isEditing ? <UserForm user={selectedUser} onSave={updatedUser => {
          if (users.some(u => u.id === updatedUser.id)) {
            setUsers(users.map(u => u.id === updatedUser.id ? updatedUser : u));
          } else {
            setUsers([...users, updatedUser]);
          }
          setSelectedUser(updatedUser);
          setIsEditing(false);
        }} onCancel={() => {
          if (selectedUser.username === '') {
            setSelectedUser(null);
          }
          setIsEditing(false);
        }} data-id="element-1275" /> : <div className="space-y-6" data-id="element-1276">
              <div className="flex justify-between items-start" data-id="element-1277">
                <div data-id="element-1278">
                  <h2 className="text-2xl font-bold" data-id="element-1279">
                    {selectedUser.firstName} {selectedUser.lastName}
                  </h2>
                  <p className="text-gray-500" data-id="element-1280">{selectedUser.username}</p>
                </div>
                <div className="flex gap-2" data-id="element-1281">
                  <button onClick={() => setIsEditing(true)} className="bg-[#ec8301] text-white rounded-lg p-2 hover:bg-[#ec8301]/90" data-id="element-1282">
                    <EditIcon className="h-5 w-5" data-id="element-1283" />
                  </button>
                  <button onClick={() => {
                setUsers(users.filter(u => u.id !== selectedUser.id));
                setSelectedUser(null);
              }} className="bg-gray-100 hover:bg-red-100 text-gray-700 hover:text-red-500 rounded-lg p-2" data-id="element-1284">
                    <TrashIcon className="h-5 w-5" data-id="element-1285" />
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-6" data-id="element-1286">
                <div data-id="element-1287">
                  <h3 className="text-lg font-medium mb-2" data-id="element-1288">Details</h3>
                  <div className="bg-gray-50 rounded-lg p-4 space-y-2" data-id="element-1289">
                    <div data-id="element-1290">
                      <span className="text-gray-600" data-id="element-1291">E-Mail:</span>
                      <span className="ml-2" data-id="element-1292">{selectedUser.email}</span>
                    </div>
                    <div data-id="element-1293">
                      <span className="text-gray-600" data-id="element-1294">Abteilung:</span>
                      <span className="ml-2" data-id="element-1295">{selectedUser.department}</span>
                    </div>
                    <div data-id="element-1296">
                      <span className="text-gray-600" data-id="element-1297">Status:</span>
                      <span className={`ml-2 ${selectedUser.isActive ? 'text-green-600' : 'text-gray-600'}`} data-id="element-1298">
                        {selectedUser.isActive ? 'Aktiv' : 'Inaktiv'}
                      </span>
                    </div>
                  </div>
                </div>
                <div data-id="element-1299">
                  <h3 className="text-lg font-medium mb-2" data-id="element-1300">Berechtigungen</h3>
                  <div className="bg-gray-50 rounded-lg p-4" data-id="element-1301">
                    <ul className="space-y-2" data-id="element-1302">
                      {permissionGroups.map(group => group.permissions.filter(permission => selectedUser.permissions.includes(permission.id)).map(permission => <li key={permission.id} className="flex items-center gap-2" data-id="element-1303">
                              <CheckCircleIcon className="h-4 w-4 text-green-500" data-id="element-1304" />
                              <span data-id="element-1305">{permission.name}</span>
                            </li>))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}